module.exports = __webpack_public_path__ + "img/Painel 3.0d46ea25.jpg";